export const selectPresence = (state) => state.chat.presence;
export const selectAgentSocket = (state) => state.chat.agentSocket;
export const selectReauthRequired = (state) => state.chat.reauth;

export const selectPool = (state) => state.chat.pool;
export const selectInbox = (state) => state.chat.inbox;
export const selectInboxStatus = (state) => state.chat.inbox.status;
export const selectInboxQueue = (state) => state.chat.inbox.queue;
export const selectAgents = (state) => state.chat.agents;
export const selectAgentsError = (state) => state.chat.agentsError;
export const selectAudit = (state) => state.chat.audit;

export const selectThread = (state) => state.chat.thread;
export const selectThreadId = (state) => state.chat.thread.id;
export const selectThreadMessages = (state) => state.chat.thread.messages;

export const selectConsoleVariant = (state) => state.chat.variant;

export const selectSupportHistory = (state) => state.chat.supportHistory;
export const selectDeviceCard = (state) => state.chat.deviceCard;
